// class ProductSwitcher extends HTMLElement {
//     constructor() {
//         super();
//         this.sizeOptions = this.querySelectorAll('.size-option');
//         this.productCache = new Map();
//         this.mainContainer = document.querySelector('#MainContent');
//     }

//     connectedCallback() {
//         this.attachEventListeners();
//         this.preloadProducts();
//     }

//     attachEventListeners() {
//         this.sizeOptions.forEach(option => {
//             option.addEventListener('click', this.handleProductChange.bind(this));
//         });
//     }

//     async handleProductChange(event) {
//         const option = event.currentTarget;
//         const productHandle = option.dataset.productHandle;

//         try {
//             document.dispatchEvent(new CustomEvent('theme:loading:start'));

//             // Remove active class from all options
//             this.sizeOptions.forEach(opt => opt.classList.remove('active'));
//             option.classList.add('active');

//             // Get cached content or fetch new
//             let productContent = this.productCache.get(productHandle);
//             if (!productContent) {
//                 productContent = await this.fetchProductContent(productHandle);
//                 this.productCache.set(productHandle, productContent);
//             }

//             // Update the product container
//             this.mainContainer.innerHTML = productContent;

//             // Force lazy loading update
//             this.updateLazyLoad();

//             // Update URL without reload
//             this.updateURL(productHandle);

//             // Trigger window resize event
//             this.triggerResize();

//             document.dispatchEvent(new CustomEvent('theme:loading:end'));
//         } catch (error) {
//             console.error('Error switching product:', error);
//             document.dispatchEvent(new CustomEvent('theme:loading:end'));
//         }
//     }

//     async fetchProductContent(handle) {
//         const response = await fetch(`/products/${handle}?view=ajax`);
//         return await response.text();
//     }

//     preloadProducts() {
//         this.sizeOptions.forEach(option => {
//             const handle = option.dataset.productHandle;
//             if (handle !== this.mainContainer.dataset.productHandle) {
//                 this.fetchProductContent(handle)
//                     .then(content => this.productCache.set(handle, content));
//             }
//         });
//     }

//     updateURL(handle) {
//         const newURL = `/products/${handle}`;
//         window.history.pushState({ path: newURL }, '', newURL);
//     }

//     updateLazyLoad() {
//       if (window.lazySizes) {
//           window.lazySizes.autoSizer.checkElems();
//           window.lazySizes.loader.checkElems();
          
//           // Force update on all lazyload images
//           const lazyImages = document.querySelectorAll('img.lazyload');
//           lazyImages.forEach(img => {
//               window.lazySizes.loader.unveil(img);
//               // Add loading="eager" to force immediate loading
//               img.setAttribute('loading', 'eager');
//           });
//       }
  
//       // Trigger multiple resize events to ensure proper rendering
//       setTimeout(() => {
//           window.dispatchEvent(new Event('resize'));
//       }, 100);
  
//       setTimeout(() => {
//           window.dispatchEvent(new Event('resize'));
//           // Force refresh lazySizes after resize
//           if (window.lazySizes) {
//               window.lazySizes.autoSizer.checkElems();
//           }
//       }, 500);
//   }


//     triggerResize() {
//         // Dispatch resize event after a short delay
//         setTimeout(() => {
//             window.dispatchEvent(new Event('resize'));
//         }, 100);

//         // Dispatch another resize event after content likely loaded
//         setTimeout(() => {
//             window.dispatchEvent(new Event('resize'));
//         }, 500);
//     }
// }

// customElements.define('product-switcher', ProductSwitcher);
// document.addEventListener('lazybeforeunveil', function(e) {
//     const target = e.target;
//     if (target.tagName === 'IMG') {
//         target.addEventListener('load', function() {
//             target.classList.add('lazyloaded');
//         });
//     }
// });

// document.addEventListener('DOMContentLoaded', function() {
//     if (window.lazySizes) {
//         window.lazySizes.init();
//     }
// });
class ProductSwitcher extends HTMLElement {
    constructor() {
        super();
        this.sizeOptions = this.querySelectorAll('.size-option');
    }

    connectedCallback() {
        this.attachEventListeners();
    }

    attachEventListeners() {
        this.sizeOptions.forEach(option => {
            option.addEventListener('click', this.handleProductChange.bind(this));
        });
    }

    handleProductChange(event) {
        const option = event.currentTarget;
        const productHandle = option.dataset.productHandle;
        
        // Simple redirect to the product page
        window.location.href = `/products/${productHandle}`;
    }
}

customElements.define('product-switcher', ProductSwitcher);
